// =========================================
// AURALYA - BOUTON ATC + PRIX DYNAMIQUE
// =========================================

console.log('🎨 Script Bouton ATC Auralya chargé');

// Fonction pour formater le prix en euros
function formatPrice(priceCents) {
  if (typeof priceCents !== 'number' || !isFinite(priceCents)) {
    return '';
  }
  const euros = (priceCents / 100).toFixed(2).replace('.', ',');
  return `${euros}€`;
}

// Fonction pour extraire le prix du bundle sélectionné
function getSelectedBundlePrice() {
  console.log('💰 Récupération du prix du bundle...');
  
  // Trouver le radio coché
  const checkedInput = document.querySelector('.kaching-bundles input[type="radio"]:checked');
  
  if (!checkedInput) {
    console.warn('⚠️ Aucun bundle sélectionné');
    return null;
  }

  // Trouver le parent
  const barElement = checkedInput.closest('.kaching-bundles__bar');
  
  if (!barElement) {
    console.warn('⚠️ Element parent non trouvé');
    return null;
  }

  const textContent = barElement.textContent || '';
  
  // Chercher le prix dans le DOM
  const priceSelectors = [
    '[class*="price"]:not([class*="compare"])',
    '.kaching-bundles__bar-price',
    'strong',
    'span'
  ];
  
  let priceCents = 0;
  let priceElement = null;
  
  for (const selector of priceSelectors) {
    const elements = barElement.querySelectorAll(selector);
    for (const el of elements) {
      const text = el.textContent || '';
      // Chercher un pattern prix (nombre suivi de €)
      if (/\d+[\s,\.]*€/.test(text) && !text.includes('économisez')) {
        priceElement = el;
        break;
      }
    }
    if (priceElement) break;
  }
  
  if (priceElement) {
    const priceText = priceElement.textContent;
    const cleanPrice = priceText
      .replace(/[^\d,\.]/g, '')
      .replace(',', '.');
    
    const priceFloat = parseFloat(cleanPrice || '0');
    priceCents = Math.round(priceFloat * 100);
    
    console.log('✅ Prix détecté:', priceFloat, '€');
  } else {
    // Fallback: chercher dans tout le texte
    const priceMatch = textContent.match(/(\d+(?:[,\.]\d+)?)\s*€/);
    if (priceMatch) {
      const priceStr = priceMatch[1].replace(',', '.');
      const priceFloat = parseFloat(priceStr);
      priceCents = Math.round(priceFloat * 100);
      console.log('✅ Prix trouvé via regex:', priceFloat, '€');
    }
  }

  return priceCents;
}

// Fonction pour mettre à jour le bouton
function updateButton() {
  console.log('🔄 Mise à jour du bouton...');
  
  const button = document.querySelector('#ProductSubmitButton-template--21864468488518__main, .product-form__submit');
  
  if (!button) {
    console.warn('⚠️ Bouton non trouvé');
    return;
  }

  const priceCents = getSelectedBundlePrice();
  
  if (!priceCents) {
    console.warn('⚠️ Prix non trouvé');
    return;
  }

  const priceFormatted = formatPrice(priceCents);
  
  // Trouver le span dans le bouton
  let buttonText = button.querySelector('span');
  if (!buttonText) {
    buttonText = button;
  }

  // Vérifier s'il y a déjà un élément prix
  let priceSpan = button.querySelector('.product-final-price');
  
  if (!priceSpan) {
    // Créer le span pour le prix
    priceSpan = document.createElement('span');
    priceSpan.className = 'product-final-price';
    button.appendChild(priceSpan);
  }
  
  // Mettre à jour le prix
  priceSpan.textContent = priceFormatted;
  
  // S'assurer que le texte du bouton dit "Ajouter au panier - "
  const textContent = buttonText.textContent;
  if (!textContent.includes('-')) {
    buttonText.textContent = 'Ajouter au panier - ';
  }
  
  console.log('✅ Bouton mis à jour avec le prix:', priceFormatted);
}

// Fonction pour ajuster la largeur du bouton
function adjustButtonWidth() {
  const button = document.querySelector('.product-form__buttons');
  const bundleBlock = document.querySelector('.kaching-bundles__block');
  
  if (button && bundleBlock) {
    // Le bouton doit avoir la même largeur que le bloc
    button.style.width = '100%';
    button.style.maxWidth = 'none';
    console.log('✅ Largeur du bouton ajustée');
  }
}

// Fonction d'initialisation
function initButtonPriceUpdater() {
  console.log('⚙️ Initialisation du système de prix dynamique du bouton...');

  // Ajuster la largeur du bouton
  adjustButtonWidth();

  // Mise à jour initiale
  setTimeout(() => {
    updateButton();
  }, 500);

  // Écouter les événements Kaching
  const kachingBlock = document.querySelector('kaching-bundles-block');
  
  if (kachingBlock) {
    console.log('✅ kaching-bundles-block trouvé');
    
    // Event variants-changed
    kachingBlock.addEventListener('variants-changed', () => {
      console.log('🎯 Event Kaching: variants-changed');
      setTimeout(updateButton, 100);
    });
    
    // Event deal-bar-selected
    kachingBlock.addEventListener('deal-bar-selected', () => {
      console.log('🎯 Event Kaching: deal-bar-selected');
      setTimeout(updateButton, 100);
    });
    
    console.log('✅ Event listeners Kaching configurés');
  }

  // Fallback: écouter les changements de radio manuellement
  const bundleContainer = document.querySelector('.kaching-bundles');
  
  if (bundleContainer) {
    // Changement de radio
    bundleContainer.addEventListener('change', (e) => {
      if (e.target.type === 'radio') {
        console.log('📻 Radio changé');
        setTimeout(updateButton, 100);
      }
    });
    
    // Clic sur une barre
    bundleContainer.addEventListener('click', (e) => {
      const bar = e.target.closest('.kaching-bundles__bar');
      if (bar) {
        console.log('🖱️ Clic sur barre bundle');
        setTimeout(updateButton, 200);
      }
    });
    
    console.log('✅ Event listeners fallback configurés');
  }

  console.log('✅ Système initialisé');
}

// Démarrage
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initButtonPriceUpdater);
} else {
  initButtonPriceUpdater();
}

// Debug
window.debugButtonPrice = {
  update: updateButton,
  getPrice: getSelectedBundlePrice,
  adjustWidth: adjustButtonWidth
};